function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-e1fb5242-7efb-4acf-8624-544b1333db42",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m18.028,29.058v-11.896h4.01l.601-4.656h-4.611v-2.966c0-1.345.373-2.262,2.303-2.262h2.444V3.124c-.426-.058-1.886-.183-3.584-.183-3.544,0-5.971,2.163-5.971,6.136v3.427h-3.995v4.656h3.995v11.896h4.807Z",
    style: {
      fill: "#d8d8d8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFBook);
export default __webpack_public_path__ + "static/media/FBook.03eaa356ef79ecc1cca065b361c287dd.svg";
export { ForwardRef as ReactComponent };